"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initIframeSync = void 0;
var DDT_DOMAINS = ['sta.sh', 'deviantart.com'];
var domainRegex = new RegExp("^(https?:)?\\/\\/([^.]+\\.)?(" + DDT_DOMAINS.join('|').replace('.', '\\.') + ")\\b", 'i');
function initIframeSync(logger, watcher) {
    new IframeSyncKeeper(logger, watcher);
}
exports.initIframeSync = initIframeSync;
var IframeSyncKeeper = /** @class */ (function () {
    function IframeSyncKeeper(logger, watcher) {
        var _this = this;
        // counter to keep track of the "version" of the channels list
        // used to keep consistentcy between all frames using postMessage
        this.version = 0;
        this.syncWatched = function () {
            var msg = JSON.stringify({
                ddt: true,
                version: _this.version,
                channels: _this.watcher.watching(),
            });
            var origin = '*';
            var iframes = getIframes();
            if (iframes.length) {
                _this.logger.log("syncing channels down - " + iframes.length + " frames found");
                iframes.forEach(function (element) {
                    // CI seems flaky on this line, so going really really safe...
                    element &&
                        element.contentWindow &&
                        element.contentWindow.postMessage &&
                        element.contentWindow.postMessage(msg, origin);
                });
            }
            if (isCurrentInstanceInIframe()) {
                _this.logger.log('syncing channels up');
                window.parent.postMessage(msg, origin);
            }
        };
        this.onSyncMessage = function (event) {
            var data = getMessageData(event);
            if (!data || _this.version === data.version) {
                return; // not a DDT postMessage, or already in sync
            }
            _this.version = data.version; // update version
            _this.watcher.setWatched(data.channels); // overwrite watched list
            _this.logger.log("updated watch list to v" + data.version + " in " + window.name, _this.watcher.watching());
            _this.syncWatched(); // continue passing the message
        };
        this.logger = logger;
        this.watcher = watcher;
        window.addEventListener('message', this.onSyncMessage);
    }
    return IframeSyncKeeper;
}());
function validateOrigin(url) {
    return domainRegex.test(url);
}
function isCurrentInstanceInIframe() {
    return window.parent !== window;
}
function validateMessageEvent(event) {
    return event && event.data && event.origin && validateOrigin(event.origin);
}
function validateMessageData(data) {
    return data && data.ddt && data.version;
}
function getMessageData(event) {
    if (!validateMessageEvent(event)) {
        return;
    }
    try {
        var data = JSON.parse(event.data);
        if (validateMessageData(data)) {
            return data;
        }
    }
    catch (x) {
        // not our data
    }
}
function getIframes() {
    var frames = Array.prototype.slice.call(document.querySelectorAll('iframe[src]'));
    // only include frames that are part of DDT domains
    return frames.filter(function (frame) { return validateOrigin(frame.src); });
}
//# sourceMappingURL=iframe.js.map